// Anonymised fixture for local development / manual testing of a Ride
// whose route contains a mid-route breakdown location. The virtual
// (breakdown) station is not listed in `stations[]` — only referenced by
// `workAssignmentSequences[].fromStation/toStation`, which is exactly
// the shape the store's `insertVirtualStations` helper handles.
//
// Real crew names and emails from the captured response are replaced with
// Norse-mythology placeholders so the fixture can live in source control.

const RIDE_ID = '72a3687b-29f1-4431-a454-7af75f3a58bb';

const ORIGINAL_CREW_ID = 'cc743a62-9ace-44fb-9ff1-a9c436039221';
const REPLACEMENT_CREW_ID = '277657f7-ee93-47e5-b6ac-626ac77629f8';

const ORIGINAL_CREW = { fullName: 'Ragnar Lothbrok' };
const REPLACEMENT_CREW = { fullName: 'Bjorn Ironside' };

const SNT6 = '049a9447-2544-4f5a-b4dd-3470eb261c59';
const HOU6 = '70fe4a43-595a-4723-8b23-1ed1247b62b1';
const XTX6 = '8e132e28-f0ff-4ea7-a3bc-28badc48fc8b';

export const RIDE_DETAILS_BREAKDOWN_MOCK = {
	id: RIDE_ID,
	tripNumber: '9332',
	status: 'on_sale',
	departure: '2026-07-31T12:35:00Z',
	lineCode: 'US1110',
	stations: [
		{
			id: SNT6,
			code: 'SNT6',
			name: 'San Antonio Bus Station',
			timezone: 'America/Chicago',
			departure: '2026-07-31T12:35:00Z',
			arrival: null,
			city: {
				name: 'San Antonio, TX',
				id: 'ff905672-4924-47f4-9e1c-ef551b1f88ee',
				__typename: 'City',
			},
			__typename: 'RideStation',
		},
		{
			id: HOU6,
			code: 'HOU6',
			name: 'Houston Bus Station (Greyhound)',
			timezone: 'America/Chicago',
			departure: null,
			arrival: '2026-07-31T16:00:00Z',
			city: {
				name: 'Houston, TX',
				id: '364040d5-ebfc-4628-b7b0-13e2377203c6',
				__typename: 'City',
			},
			__typename: 'RideStation',
		},
	],
	workAssignmentSequences: [
		{
			isMultiRide: true,
			sequenceGroupId: '6a2d1a17-e7dd-4176-95f9-42037139d1e4',
			rideId: RIDE_ID,
			crewMember: {
				id: ORIGINAL_CREW_ID,
				fullName: ORIGINAL_CREW.fullName,
				__typename: 'CrewMember',
			},
			breakdown: {
				workAssignmentSequenceGroupId: '6a2d1a17-e7dd-4176-95f9-42037139d1e4',
				incidentTimestamp: '2026-07-31T13:50:00Z',
				reason: 'driverFatigue',
				station: {
					id: XTX6,
					code: 'XTX6',
					name: 'GHDummy TX Breakdowns Only',
					__typename: 'Station',
				},
				note: 'Test breakdown fixture for local development.',
				deadhead: null,
				inboundTravelingWorkAssignment: {
					id: 'b314e8cb-1deb-4b82-84f0-342a3e814e52',
					crewMember: {
						id: REPLACEMENT_CREW_ID,
						fullName: REPLACEMENT_CREW.fullName,
						__typename: 'Driver',
					},
					fromStation: {
						name: 'San Antonio Bus Station',
						code: 'SNT6',
						__typename: 'Station',
					},
					toStation: {
						name: 'GHDummy TX Breakdowns Only',
						code: 'XTX6',
						__typename: 'Station',
					},
					fromTimestamp: '2026-07-31T13:55:00Z',
					toTimestamp: '2026-07-31T15:30:00Z',
					__typename: 'WorkAssignment',
				},
				replacementCrewMember: {
					id: REPLACEMENT_CREW_ID,
					fullName: REPLACEMENT_CREW.fullName,
					driverCard: 'DC-BJORN-01',
					__typename: 'CrewMember',
				},
				parallelRide: null,
				postIncidentDrivingAssignments: {
					sequenceGroupId: '3c5976df-c8f9-49ef-8bb8-499cf5f1fe2e',
					crewMember: {
						id: REPLACEMENT_CREW_ID,
						fullName: REPLACEMENT_CREW.fullName,
						__typename: 'CrewMember',
					},
					workAssignmentSequences: [
						{
							fromStation: {
								code: 'XTX6',
								name: 'GHDummy TX Breakdowns Only',
								__typename: 'Station',
							},
							toStation: {
								code: 'HOU6',
								name: 'Houston Bus Station (Greyhound)',
								__typename: 'Station',
							},
							fromTimestamp: '2026-07-31T15:45:00Z',
							toTimestamp: '2026-07-31T17:55:00Z',
							__typename: 'WorkAssignmentSequenceV2',
						},
					],
					__typename: 'WorkAssignmentDetailsResponseV2',
				},
				outboundTravelingWorkAssignment: null,
				createdAt: '2026-07-31T16:33:38.312273Z',
				updatedAt: '2026-07-31T16:33:38.312285Z',
				updatedBy: 'test@example.com',
				__typename: 'Breakdown',
			},
			fromStation: {
				id: SNT6,
				name: 'San Antonio Bus Station',
				__typename: 'Station',
			},
			toStation: {
				id: XTX6,
				name: 'GHDummy TX Breakdowns Only',
				__typename: 'Station',
			},
			fromTimestamp: '2026-07-31T12:35:00Z',
			toTimestamp: '2026-07-31T13:50:00Z',
			activityType: 'driving',
			status: 'confirmed',
			workAssignments: [
				{
					crewMember: {
						id: ORIGINAL_CREW_ID,
						fullName: ORIGINAL_CREW.fullName,
						__typename: 'Driver',
					},
					status: 'confirmed',
					version: 1,
					id: '749d6c6e-30ac-4e0f-a401-da61c3b29020',
					fromStation: {
						id: SNT6,
						name: 'San Antonio Bus Station',
						__typename: 'Station',
					},
					toStation: {
						id: XTX6,
						name: 'GHDummy TX Breakdowns Only',
						__typename: 'Station',
					},
					__typename: 'WorkAssignment',
				},
			],
			run: null,
			job: null,
			extraActivities: [
				{
					fromTimestamp: '2026-07-31T16:00:00Z',
					toTimestamp: '2026-07-31T16:05:00Z',
					id: 'c92f8917-0f04-41d4-8328-1cd81f92a9ca',
					version: 3,
					status: 'rejected',
					fromStation: {
						id: HOU6,
						code: 'HOU6',
						__typename: 'Station',
					},
					toStation: {
						id: HOU6,
						code: 'HOU6',
						__typename: 'Station',
					},
					activityType: 'garaging',
					__typename: 'WorkAssignment',
				},
				{
					fromTimestamp: '2026-07-31T16:05:00Z',
					toTimestamp: '2026-07-31T16:20:00Z',
					id: 'f3628f09-41b9-4914-b223-4f7030f4406c',
					version: 3,
					status: 'rejected',
					fromStation: {
						id: HOU6,
						code: 'HOU6',
						__typename: 'Station',
					},
					toStation: {
						id: HOU6,
						code: 'HOU6',
						__typename: 'Station',
					},
					activityType: 'signOff',
					__typename: 'WorkAssignment',
				},
			],
			__typename: 'WorkAssignmentSequence',
		},
		{
			isMultiRide: false,
			sequenceGroupId: '3c5976df-c8f9-49ef-8bb8-499cf5f1fe2e',
			rideId: RIDE_ID,
			crewMember: {
				id: REPLACEMENT_CREW_ID,
				fullName: REPLACEMENT_CREW.fullName,
				__typename: 'CrewMember',
			},
			breakdown: null,
			fromStation: {
				id: XTX6,
				name: 'GHDummy TX Breakdowns Only',
				__typename: 'Station',
			},
			toStation: {
				id: HOU6,
				name: 'Houston Bus Station (Greyhound)',
				__typename: 'Station',
			},
			fromTimestamp: '2026-07-31T15:45:00Z',
			toTimestamp: '2026-07-31T17:55:00Z',
			activityType: 'driving',
			status: 'confirmed',
			workAssignments: [
				{
					crewMember: {
						id: REPLACEMENT_CREW_ID,
						fullName: REPLACEMENT_CREW.fullName,
						__typename: 'Driver',
					},
					status: 'confirmed',
					version: 1,
					id: '66c36bbc-92f5-47a2-a480-4c77b46f7b7d',
					fromStation: {
						id: XTX6,
						name: 'GHDummy TX Breakdowns Only',
						__typename: 'Station',
					},
					toStation: {
						id: HOU6,
						name: 'Houston Bus Station (Greyhound)',
						__typename: 'Station',
					},
					__typename: 'WorkAssignment',
				},
			],
			run: null,
			job: null,
			extraActivities: [],
			__typename: 'WorkAssignmentSequence',
		},
	],
	vehicleAssignments: [
		{
			mobilityPartnerName: 'Dallas GLI',
			plateNumber: 'K191875',
			busNumber: '87109',
			vehicleType: 'bus',
			fromStationId: SNT6,
			toStationId: HOU6,
			__typename: 'VehicleAssignment',
		},
	],
	activityTypeConfigs: [
		{ activityType: 'driving', limit: 1, __typename: 'ActivityTypeConfig' },
		{ activityType: 'hosting', limit: 0, __typename: 'ActivityTypeConfig' },
	],
	runs: [
		{
			id: '19eea52f-f21c-4560-9b27-851b747a640c',
			name: '3506',
			description: '',
			effectiveDate: '2026-06-25',
			expireDate: '2026-08-06',
			concessionOwners: [
				{
					id: 'cf32eb76-0ade-43dd-a399-fbace9165325',
					name: 'Greyhound Lines, Inc.',
					__typename: 'ConcessionOwner',
				},
			],
			runCity: {
				id: '364040d5-ebfc-4628-b7b0-13e2377203c6',
				name: 'Houston, TX',
				timezone: 'America/Chicago',
				__typename: 'City',
			},
			__typename: 'Run',
		},
	],
	jobs: [
		{
			id: '7fe43428-4b86-4551-976a-a407993ac9de',
			code: 'A',
			runId: '19eea52f-f21c-4560-9b27-851b747a640c',
			distanceKm: 636,
			durationSeconds: 24600,
			__typename: 'Job',
		},
	],
	__typename: 'Ride',
};
